import * as ko from "knockout";
import {template as tpl, viewModel as EditMessageTemplate} from "./edit";
import {global} from "../../appContext";
import {IFormTemplate, IMessage, IRuleset} from "../../index";
import {CREATING_MESSAGE} from "../../constants/Language";
import {getCancelButton, getSubmitButton} from "../../constants/RouteDefinitions";
import {nsRoute} from "../../util/route";
import PromiseRequest from "../../req/PromiseRequest";
import {ObjectTypeId} from "../../constants";
import {nsMessages} from "./fn";
import ButtonOrder = nsRoute.ButtonOrder;

export const template = tpl

export class viewModel extends EditMessageTemplate {

    private readonly req_getruleset: PromiseRequest = new PromiseRequest('getruleset')
    private readonly req_getformtemplate: PromiseRequest = new PromiseRequest('getformtemplate')
    private readonly requests: PromiseRequest[] = []

    protected override init(): Promise<void> {
        return super.init()
            .catch(reason => {
                super.initError(reason)
                global.eHubManager.eHubManager.stop()
            });
    }

    protected override initAfter(): Promise<void> {
        return Promise.resolve()
            .then(() => this.req_getruleset
                .request({
                    id: this.data.$original.rulesetid,
                })
                .then((data: [IRuleset]) => {
                    this.data.ruleset(data[0])
                })
            )
            .then(() => {
                const ruleset = this.data.ruleset()
                if (!ruleset) {
                    return
                }
                const ruleWithFormId = nsMessages.getRuleWithFormId(ruleset)
                if (!ruleWithFormId) {
                    return;
                }
                return this.req_getformtemplate
                    .request({id: ruleWithFormId.argument})
                    .then((data: [IFormTemplate]) => this.formTemplate(data[0]))
            })
            .then(super.initAfter.bind(this))
    }

    protected override setupPageButtons() {
        this.pageButtons.add(getCancelButton(() => {
            global.eHubManager.fnReject('abort')
        }))
        this.pageButtons.add({
            onClick: this.onPreviewClick.bind(this),
            enabled: this.isFormValid.bind(this),
            icon: 'fa-eye',
            label: 'preview',
            cssClass: 'action',
            order: ButtonOrder.PREVIEW,
        })
        this.pageButtons.add(getSubmitButton({
            attr: {type: 'submit'},
            onClick: this.onSubmit.bind(this),
            enabled: this.isFormValid.bind(this),
        }))
    }

    protected override isRulesetOptional = ko.pureComputed((): boolean => {
        return true
    })

    protected override readonly objecttypeid = ko.pureComputed((): ObjectTypeId | null => {
        return ObjectTypeId.FormData
    });

    override onSubmit() {
        this.isReady(false);
        this.messageData({message: CREATING_MESSAGE});

        return Promise.resolve()
            .then(() => {
                const data = this.getSubmitData();
                data.body = encodeURIComponent(data.body)
                const jmessage = JSON.stringify(data);

                this.req_submit.abort();
                return this.req_submit
                    .request({jmessage: jmessage})
                    .then((data: [IMessage]) => {
                        this.data.$original = data[0]
                    })
            })
            .then(() => {
                global.cacheManager.removeCache("searchmessage");
                global.cacheManager.removeCache("getmessage");
                global.cacheManager.removeCache('getehubprocess');
                global.cacheManager.removeCache('getformtemplate');

                // changes to the message flow could have changed one or more expressions in the subject/body -
                // therefore remove chache of any expressions evaluated
                global.cacheManager.removeCache('evaluateexpression');

                global.eHubManager.fnResolve(true)
            })
            .catch((reason: string) => {
                global.eHubManager.fnReject(reason)
            });

    }

    override dispose() {
        super.dispose();
        this.requests.forEach(o => o.abort())
        this.req_getruleset.abort()
        this.req_getformtemplate.abort()
        global.eHubManager.fnReject?.('abort')
    }

}
